import Sortable from "sortablejs";
import middleware from "../../middleware";
import isFunction from "lodash/isFunction";
import reorder from "./reorder";

class WeaSortable extends React.Component {
  constructor(props) {
    super(props);
    this.sortableEl = null;
  }
  componentDidMount() {
    if (!this.sortableEl) this.initSortable();
  }

  componentWillReceiveProps(nextProps) {
    const { draggableType, datas } = nextProps;
    const { draggableType: _dtype, datas: _d } = this.props;
    if (draggableType !== _dtype && this.sortableEl) {
      const newHandle = draggableType === "row" ? "" : ".wea-table-move";
      this.sortableEl.option("handle", newHandle);
    }
  }

  componentDidUpdate() {
    if (!this.sortableEl) this.initSortable();
  }

  componentWillUnmount() {
    this.sortableEl && this.sortableEl.destroy();
  }

  initSortable = () => {
    let { container, draggableType, draggableIconContainer } = this.props;
    if (typeof container == "string") {
      container = jQuery(container, ReactDOM.findDOMNode(this))[0];
    } else if (isFunction(container)) {
      container = container();
    }
    if (!container) {
      this.sortableTimeout = setTimeout(() => {
        if (!this.sortableEl) this.initSortable();
      }, 500);
      return;
    }
    if (this.sortableTimeout) {
      clearTimeout(this.sortableTimeout);
    }
    let sortableOptions = {
      animation: 150,
      ghostClass: "blue-background-class",
      onEnd: this.onEnd
    };
    if (draggableType !== "row")
      sortableOptions = { ...sortableOptions, handle: draggableIconContainer };
    this.sortableEl = new Sortable(container, sortableOptions);
  };

  onEnd = target => {
    let { datas, onDrop } = this.props;
    if (Array.isArray(datas) && isFunction(onDrop)) {
      const { oldIndex, newIndex } = target;
      const moveItem = datas[oldIndex];
      const newDatas = reorder(datas, oldIndex, newIndex);

      onDrop(newDatas, oldIndex, newIndex, moveItem);
    }
  };

  render() {
    return this.props.children;
  }
}

WeaSortable.propTypes = {
  container: React.PropTypes.any, //可拖拽区域
  draggableIconContainer: React.PropTypes.any, //图标拖拽区域
  onDrop: React.PropTypes.func, //拖拽结束时触发的方法，第1个参数是拖拽的DOM节点，第二个参数是所放下的位置下方的DOM节点。
  draggableType: React.PropTypes.String, //拖拽类型
  datas: React.PropTypes.array, //数组
  children: React.PropTypes.any //包裹区域
};

const Com = middleware(WeaSortable, "WeaNewDragula");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-new-dragula/index.js